import { Capacitor } from '@capacitor/core';

/** Gesture / 3-button nav bar height when WebView safe-area env is 0 (px). */
const ANDROID_NAV_FALLBACK = 48;

function measureAndroidBottomInset() {
  const vv = window.visualViewport;
  if (!vv) return ANDROID_NAV_FALLBACK;
  const gap = window.innerHeight - vv.height - vv.offsetTop;
  return gap > 0 ? Math.ceil(gap) : ANDROID_NAV_FALLBACK;
}

function applyAndroidBottomInset() {
  document.documentElement.style.setProperty(
    '--native-safe-bottom',
    `${measureAndroidBottomInset()}px`,
  );
}

/** Apply extra bottom inset for Capacitor Android (WebView often reports 0 safe-area). */
export function initNativeSafeArea() {
  if (!Capacitor.isNativePlatform()) return;

  const platform = Capacitor.getPlatform();
  document.documentElement.classList.add('native-app', `native-${platform}`);

  if (platform !== 'android') return;

  applyAndroidBottomInset();

  const vv = window.visualViewport;
  if (!vv) return;

  const update = () => applyAndroidBottomInset();
  vv.addEventListener('resize', update);
  vv.addEventListener('scroll', update);
  window.addEventListener('orientationchange', () => {
    window.setTimeout(update, 150);
  });
}
